import { FormInstance } from 'antd'
import { debounce } from 'lodash'

type Callback<T> = (values: T, changedValues?: T) => void | Promise<void>

// We should use WithValidation functions in most places UNLESS
//  The form contains an async populated field (e.g. address autocomplete) or the form autosaves (e.g. drafts),
//  as these will fail validation and prevent the form from autosaving or populating project names based on the address for example
// TODO - BPID-2221 turn-on-form-validation-before-save-where-safe-to-do-so

export const onFormChangeDebounceWithValidation = <T>(
  form: FormInstance,
  callback: Callback<T>,
  time = 500
) => {
  return debounce((changedValues, allValues) => {
    const allDirty = Object.keys(changedValues).every(form.isFieldTouched)
    if (allDirty) {
      form.validateFields().then(() => {
        callback?.(allValues, changedValues)
      })
    }
  }, time)
}

export const onFormChangeDebounce = <T>(
  form: FormInstance,
  callback: Callback<T>,
  time = 500
) => {
  return debounce((changedValues, allValues) => {
    const allDirty = Object.keys(changedValues).every(form.isFieldTouched)
    if (allDirty) {
      callback?.(allValues, changedValues)
    }
  }, time)
}

export const onFormChangeWithValidation = <T>(
  form: FormInstance,
  callback: Callback<T>
) => {
  return (changedValues, allValues) => {
    const allDirty = Object.keys(changedValues).every(form.isFieldTouched)
    if (allDirty) {
      form.validateFields().then(() => {
        callback?.(allValues, changedValues)
      })
    }
  }
}

export const onFormChange = <T>(form: FormInstance, callback: Callback<T>) => {
  return (changedValues, allValues) => {
    const allDirty = Object.keys(changedValues).every(form.isFieldTouched)
    if (allDirty) {
      form.validateFields().then(() => {
        callback?.(allValues, changedValues)
      })
    }
  }
}
